import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Alert, Avatar, Button, Chip, CircularProgress, Fab, FormHelperText, Grid2, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import Grid from '@mui/material/Grid2';
import './home.sass'
import { useForm, SubmitHandler } from 'react-hook-form';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { utils, read, writeFile } from 'xlsx';
import CheckIcon from '@mui/icons-material/Check';

import {Scanner} from '@yudiel/react-qr-scanner';

import FormControl, { useFormControl } from '@mui/material/FormControl';

import WifiOffOutlinedIcon from '@mui/icons-material/WifiOffOutlined';
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined';

import DateRangePicker from '@wojtekmaj/react-daterange-picker';

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import SearchIcon from '@mui/icons-material/Search';


import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import StarIcon from '@mui/icons-material/Star';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

import TextField from '@mui/material/TextField';
import UserCard from '../Components/UserCard/UserCard';
import { Check, CircleNotificationsOutlined, DateRangeRounded } from '@mui/icons-material';

import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

import { DataGrid, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import {apiEvent, apiTickets} from '../Components/ApiCall';

import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';


type FormData = {
  card_number: string;
};

const dateFormatter = (dateTime:string)=>{

  const options:any = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  const oldDate = new Date(dateTime)
  return oldDate.toLocaleDateString('pt-BR', options).split(',').join(' ')
}

const EventCardList = () => {

  const processRowUpdate = (after:any, before:any) => {
    console.log(before)
    console.log('---')
    console.log(after)
    return after
  }



  const { register, handleSubmit, formState: { errors }, setValue } = useForm<FormData>();

  const onSubmit: SubmitHandler<FormData> = async (data) => {

    setVai(true)

    setSuccess(false);
    setLoading(true);
    console.log(data)
    let response:any;
    
    try{
     response = await apiTickets.get(`/card/${data.card_number}?pageSize=9999999`);
    }catch(e){
      setTicketLogList([])
    }
   

    if(Array.isArray(response.data?.data)){
      setTicketLogList(response.data?.data)
    }else{
      setTicketLogList([response.data?.data])
    }
    setVai(false)
    
  };

  const [rola, setRola] = useState<any>([])
  const [vai, setVai] = useState<boolean>(true)

  const [checkInSearchType, setCheckInSearchType] = useState<any>('cards')
  
  const [cartSummary, setCartSummary] = useState<any>({
      total: 0,
      active: 0,
      canceled: 0
  })


  const [ticketLogList, setTicketLogList] = useState<any>()

    const handleProcessRowUpdateError = (item:any) => {
      console.log(item)
      return item
    }

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [openScaner, setOpenScaner] = React.useState(false);
    const handleOpenScaner = () => {setScanSession(1);setOpenScaner(true)};
    const handleCloseScaner = () => {setScanSession(1);setOpenScaner(false);};
    const [scanSession, setScanSession] = React.useState(1);
    
    
    const [loading, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const timer = React.useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

    const [eventList, setEventList] = useState<any>([])
    const [selectedEvent, setSelectedEvent] = useState<any>('c4b722a8-4376-4f0f-9d12-b8175a9ef100')

const fetchData = async (eventId:any = selectedEvent) => {
  try {

    setVai(true)
    setSelectedEvent(eventId)
    let response:any;
    
    const companyId = sessionStorage.getItem('company_id') ||  'na'
    const eventResponse = await apiEvent.get(`/event/group/events/company/${companyId}`);
    // const activeEvents = response.data.events.filter((item:any) => item.isActive)
    setEventList(eventResponse.data.events)

    try{
      response = await apiTickets.get(`/card/all/${eventId}?pageSize=9999999`);
     }catch(e){
       setTicketLogList([])
     }
   
     
    console.log(response.data);

    setTicketLogList(response.data?.data)
    setCartSummary({
      total: response.data?.count || '--',
      active: response.data?.countActive || '--',
      canceled: response.data?.countCanceled || '--'
  })



  setVai(false)

    const _temp_firmware_summary = {
      firmware_ok: 0,
      firmware_waiting: 0,
      firmware_nok: 0
  }


  const _temp_cmp = sessionStorage.getItem('company_slug') || null;
  let _temp_bebox_version = '2.05'
  if(_temp_cmp === 'gremio'){
    _temp_bebox_version = '2.08'
  }else if(_temp_cmp === 'fonte-nova'){
    _temp_bebox_version = '2.13'
  }

    const dataValues = response.data.map((item:any, index:any) => {

      console.log(' > > > > >')
      console.log(item.healthCheck)
      let _item_healthCheck;
      try {
        _item_healthCheck = item.healthCheck;
      } catch (error) {
        _item_healthCheck = null;
      }
      if(_item_healthCheck){
        if(_item_healthCheck.its === 'alive'){
          if(_item_healthCheck.version === _temp_bebox_version){
            _temp_firmware_summary.firmware_ok++
          }else{
            _temp_firmware_summary.firmware_waiting++
          }
        }else if(_item_healthCheck.its === 'down'){
          _temp_firmware_summary.firmware_nok++
        }else{
          _temp_firmware_summary.firmware_waiting++
        }
      }
      return {
        id: ++index,
        bebox_name: item.beboxName || 'lab_s2',
        server_name: item.serverName,
        device_name: item.deviceName,
        sector: item.sector,
        gate: item.gate,
        device_ip: item.deviceIP,
        device_firmware: item.deviceFirmware,
        bebox_version: item.beboxVersion,
        device_type: item.deviceType,
        device_group: item.deviceGroup,
        last_time_online: item.updatedAt,
        action: 'star',
        status: item.status,
        beboxIP: item.beboxIP,
        deviceName: item.deviceName,
        beboxName: item.beboxName,
        healthCheck: _item_healthCheck
      }
    })
    setRola(dataValues)
    // setVai(false)

  } catch (error) {
    console.error(error);
  }
};

  const downloadReport = async () => {


// const reportFile = await userList.map((item:any) => {
//   return {
//     tem_biometria: item.biometry === 'yes' ? 'sim':'não',
//     onboarding: `https://ingresse.bepass.com.br?token=?${item.token}`,
//     id_sessao: item.session_id,
//     documento: item.document,
//     nome: item.user_name,
//     ingresso: item.user_ticket
//   }
// })
    const worksheet = utils.json_to_sheet(ticketLogList);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'relatorio');
    writeFile(workbook, `relatorio-log-acesso.xlsx`);
  }


  const handleChange = (event:any) => {
    setCheckInSearchType(event.target.value);
    console.log(event.target.value)
  }


const columns: GridColDef<any>[] = [
  { 
    field: 'cardCode',
    headerName: 'Cartão',
    width: 250
  },{ 
    field: 'eventName',
    headerName: 'Evento',
    width: 350
  },{ 
    field: 'status',
    headerName: 'Status',
    width: 110
  },{ 
    field: 'ticketToken',
    headerName: 'Hash',
    width: 230,
  }
];

function getRowId(row:any) {
  return Math.random();
}
const columnsMobile: GridColDef<any>[] = [
  {
    field: 'bebox_version',
    headerName: 'Versão bebox',
    width: 80,
    editable: true
  },
  { 
    field: 'device_name',
    headerName: 'Device',
    width: 140,
    editable: true,
    renderCell: (params) => {
      return <span className='single-status'>
        {params.row.healthCheck ? (
          
          params.row.healthCheck.its === 'down' ? (
            <WifiOffOutlinedIcon className='icon-inactive' />
          ):(
            <WifiOutlinedIcon className='icon-active' />
          )
        ):(
          <WifiOffOutlinedIcon className='icon-inactive' />
        )}
      {params.row.healthCheck?.totem_id || `bebox_${params.row.device_name}`}
      </span>    },
  },{ 
    field: 'device_ip',
    headerName: 'Device IP',
    width: 140,
    editable: true,
  },{ 
    field: 'bebox_name',
    headerName: 'tag',
    width: 140,
    editable: true,
  }
];



const [paginationModel, setPaginationModel] = React.useState({
  page: 0,
  pageSize: 5,
});

// const { isLoading, rows, pageInfo } = useState<any>({
//   rows: [],
//   pageInfo: {
//     totalRowCount: 0,
//   },
//   isLoading: false
// });


// Some API clients return undefined while loading
// Following lines are here to prevent `rowCount` from being undefined during the loading
// const rowCountRef = React.useRef(pageInfo?.totalRowCount || 0);

// const rowCount = React.useMemo(() => {
//   if (pageInfo?.totalRowCount !== undefined) {
//     rowCountRef.current = pageInfo.totalRowCount;
//   }
//   console.log('mexeu aqui', rowCountRef.current, pageInfo?.totalRowCount)
//   return rowCountRef.current;
// }, [pageInfo?.totalRowCount]);

useEffect(() => {
  fetchData()
}, [])

  return (
    <Box>

{eventList && eventList.length > 0 && (
   <Box className="event-select">
   <FormControl  fullWidth>
           <InputLabel id="demo-simple-select-label">Escolher Evento</InputLabel>
           <Select
             labelId="demo-simple-select-label"
             id="demo-simple-select"
             // value={age}
             label="Escolher"
             onChange={(e) => {fetchData(e.target.value)}}
           >
             {eventList && eventList.map((item:any, index:any) => (
               <MenuItem  key={index} value={item.events[0].id}>[{item.events[0].externalId}] {item.name}</MenuItem>
             ))}

           </Select>
         </FormControl>
   </Box>
)}

      <Box className="header-with-button" sx={{ display: 'flex', justifyContent: "space-between" }}>
        <Typography variant="subtitle1" component="h2">
          Lista de cartões
          {/* <FormControl  fullWidth>
          <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
    <Select
      labelId="choose-event-label"
      id="choose-event"
      name="par_code"
      label="Escolher"
    onChange={handleChange}
    >
      <MenuItem value={'default'}>Acesso Gerais</MenuItem>
      <MenuItem value={'cards'}>Cartões Mifare</MenuItem>
    </Select>
    </FormControl> */}
        </Typography>



        <Box className="header-with-search">

<form className='user-search-form' onSubmit={handleSubmit(onSubmit)}>

<TextField
  label="Número do cartão"
  {...register("card_number", { required: "Cartão é obrigartório" })}
  error={!!errors.card_number}
  helperText={errors.card_number?.message}
  fullWidth
/>

    <Button
          variant="contained"
          type='submit'
          className='besafe-select-form-button'
        >
          Pesquisar
        </Button>
</form>



        
<Button variant="outlined" onClick={() => fetchData()}>Recarregar</Button>
        <Button variant="contained" onClick={() => downloadReport()}>Baixar</Button>
        </Box>

      </Box>


      <div className="card-summary-wrapper">
      <ul className="sync-symmary-status">
            <li className='status-idle'>{cartSummary.total} Total</li>
            <li className='status-done'>{cartSummary.active} Ativos</li>
            <li className='status-offline'>{cartSummary.canceled} Cancelados</li>
          </ul>
      </div>

{ticketLogList && ticketLogList.length > 0 ? (
  <Box className="data-table-wrapper">
      
  <DataGrid
          sx={{ display: { xs: 'none', md: 'block' }}}
          rows={ticketLogList}
          columns={columns}
          getRowId={getRowId}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 50,
              },
            },
          }}
          pageSizeOptions={[50]}
          checkboxSelection
          disableRowSelectionOnClick
          processRowUpdate={(updatedRow, originalRow) =>
            processRowUpdate(updatedRow, originalRow)
          }
          onProcessRowUpdateError={handleProcessRowUpdateError}
          loading={vai}
          slotProps={{
            loadingOverlay: {
              variant: 'linear-progress',
              noRowsVariant: 'skeleton',
            },
          }}


          // rowCount={rowCount}
          // paginationModel={paginationModel}
          // paginationMode="server"
          // onPaginationModelChange={setPaginationModel}
        />
  
  
        {/* enhance this */}
        <DataGrid
          sx={{ display: { xs: 'block', md: 'none' }}}
          rows={rola}
          columns={columnsMobile}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 20,
              },
            },
          }}
          pageSizeOptions={[20]}
          disableRowSelectionOnClick
          processRowUpdate={(updatedRow, originalRow) =>
            processRowUpdate(updatedRow, originalRow)
          }
          onProcessRowUpdateError={handleProcessRowUpdateError}
          loading={vai}
          slotProps={{
            loadingOverlay: {
              variant: 'linear-progress',
              noRowsVariant: 'skeleton',
            },
          }}
        />
        </Box>
):(
<Alert severity="info" color="warning">
          Não temos registro de acessos para esse evento.
        </Alert>
)}
      
    </Box>
  )
};

export default EventCardList;
